// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_d_d","clinicsSelect":"styles_clinicsSelect__2_2kd"};